import type {
  CheckResponse,
  GoogleAuthResponse,
  SigninResponse,
  UpdateUserResponse,
} from '@/api';
import { UserData } from '../models';

const check = (response: CheckResponse): UserData => {
  const data: UserData = response.user;
  return data;
};

const current = (response: CheckResponse): UserData => {
  const data: UserData = response.user;
  return data;
};

const signin = (response: SigninResponse): UserData => {
  const data: UserData = response.user;
  return data;
};

const signinGoogle = (response: GoogleAuthResponse): UserData => {
  const data: UserData = response.user;
  return data;
};

const changeFullNameEmail = (response: UpdateUserResponse): UserData => {
  const data: UserData = response.user;
  return data;
};

export { check, signin, signinGoogle, changeFullNameEmail, current };
